import {type DimensionAsObject} from './types';

export type ContainFit = DimensionAsObject & {
  /** Zoom level, in percent of the natural size, at which the image fits the container. */
  zoomToFitPercentage: number;
};

/**
 * Fits an image of the given natural size inside a container without cropping,
 * keeping its aspect ratio. Dimensions are rounded to whole pixels and the
 * percentage is floored, matching the fullscreen modal.
 */
export function containFit(
  natural: DimensionAsObject,
  container: DimensionAsObject
): ContainFit {
  const aspectRatio = natural.width / natural.height;
  const widthLimited = container.width / aspectRatio <= container.height;
  const width = Math.round(
    widthLimited ? container.width : container.height * aspectRatio
  );
  const height = Math.round(
    widthLimited ? container.width / aspectRatio : container.height
  );
  return {
    width,
    height,
    zoomToFitPercentage: Math.floor((width / natural.width) * 100),
  };
}
